import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../shared/common.service'; 
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { LoginLayoutService } from '../../layouts/login-layout/login-layout.service';

@Component({
  selector: 'app-resend-otp',
  templateUrl: './resend-otp.component.html',
  styleUrls: ['./resend-otp.component.css']
})
export class ResendOtpComponent implements OnInit {
  resendOtpForm: FormGroup;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public commonService: CommonService,
    public loginLayoutService: LoginLayoutService,
    // public userLayoutService: UserLayoutService
  ) {}

  ngOnInit(): void {
    this.resendOtpForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  // Getter for easier access to form controls
  get f() {
    return this.resendOtpForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // Stop if the form is invalid
    if (this.resendOtpForm.invalid) {
      return;
    }

    const emailData = this.resendOtpForm.value;

    // Call the API for resending OTP
    this.loginLayoutService.resendOtp(emailData).subscribe(
      (Response: any) => {
        if (Response.code === 1) {
          this.commonService.notifier.notify('success', 'OTP has been resent to your email.');
          this.router.navigate(['/verify-otp']);
        } else {
          this.commonService.notifier.notify('error', Response.message);
        }
      },
      (error) => {
        // console.log(error);
        this.commonService.notifier.notify('error', 'Something went wrong. Please try again.');
      }
    );
  }
}
